import { getApplianceColor } from "./helper";
import { Configuration } from '../configs/Configuration';

export function prepareWidgetData(data, mode, applianceList){
    const applianceIdOthers = 99;
    if(!data){
        data = [{id: 8, usage: 1237, cost: 99, percentage: 58},
            {id: 4, usage: 341, cost: 27, percentage: 16},
            {id: 7, usage: 151, cost: 12, percentage: 7},
            {id: 99, usage: 2528.57, cost: 202, percentage: 119}];
    }
    let seriesData = [];
    let slicedSeriesData = [];
    let totalCostOrConsumption = 0;
    //inner series
    for(let i = 0; i < data.length ; i++) {
        let isRemainingTotal = (data[i].id === applianceIdOthers);
    // ID for 'total' is 17 
        if(data[i].id !== 17){
            totalCostOrConsumption += data[i][mode];
            let appliance = {
                name: getApplianceName(data[i].id, applianceList),
                y: data[i][mode],
                isRemainingTotal: isRemainingTotal,
                color: getApplianceColor(data[i].id)
            };
            seriesData.push(appliance);
        }
    }
    //sliced series
    for(let i = 0; i < data.length ; i++) {
        let isRemainingTotal = (data[i].id === applianceIdOthers);
        // ID for 'total' is 17 
        if(data[i].id !== 17){
            let appliance = {
                name: getApplianceName(data[i].id, applianceList),
                y: data[i][mode],
                isRemainingTotal : isRemainingTotal,
                color: getApplianceColor(data[i].id)
            };
            if(i !== 0) {
                appliance["color"] = "transparent";
            }
            slicedSeriesData.push(appliance);
        }
    }
    return {seriesData: seriesData, slicedSeriesData: slicedSeriesData, totalCostOrConsumption: totalCostOrConsumption};
}

export function prepareBarChartData(data, mode ,useFakeData){
    if(!data && useFakeData){
        data = [{id: 8, category: "alwaysOn", usage: 1237, cost: 99, percentage: 58},
        {id: 4, category: "airConditioning", usage: 341, cost: 27, percentage: 16},
        {id: 7, category: "waterHeating", usage: 151, cost: 12, percentage: 7},
        {id: 99, category: "other", usage: 2528.57, cost: 202, percentage: 17}];
    }
    let highlightData = [];
    let lowLightData = [];
    let values = [];
    for(let i = 0; i< data.length ; i++){
        // ID for 'total' is 17 
        if(data[i].id !== 17){
            values.push(data[i][mode]);
            highlightData.push({y: data[i].percentage, id : data[i].id});
            lowLightData.push({y : 100-data[i].percentage, cost : data[i].cost, usage : data[i].usage});
        }
    }
    return {highlightData : highlightData , lowLightData : lowLightData, values : values, chartHeight : highlightData.length * 80};
}

export function getApplianceName(applianceId, applianceList) {
    let appName = applianceList[applianceId];
    let applianceText = Configuration.getTranslations()["APPLIANCES"];
    //Appliance ID for Other Appliances is 99
    return appName + (applianceId === 99 && applianceText ? " " + applianceText : "");
}